package org.multiplatform.kotfolio.pages.compose.side_effect

import androidx.compose.runtime.Composable
import org.multiplatform.kotfolio.components.KotlinCode
import org.multiplatform.kotfolio.components.WebImage
import org.multiplatform.kotfolio.layout.BlogLayout
import org.multiplatform.kotfolio.layout.BlogProperties
import org.multiplatform.kotfolio.layout.PageProperties
import org.multiplatform.kotfolio.util.Resources
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.em
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Ol
import org.jetbrains.compose.web.dom.Ul

@Page("/compose/side_effect/savedstate")
@Composable
fun SavedStatePage() {
    BlogLayout(
        PageProperties(
            "SavedState",
            ""
        ),
        BlogProperties("Jetpack Compose", "SavedState")
    )
    {
        Column(
            horizontalAlignment = Alignment.Start
        ) {

            KotlinCode(
                code = """
                    savedstate = 1.5.O"
                    
                    android-savedstate-compose = { group = "androidx.savedstate", name = "savedstate.compose" version.ref = "savedstate"  }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    @Serializable
                    data class Article(
                        val headline: String,
                        val text: String,
                        val likesCount: Int = 0,
                    )
                    
                    
                    @Composable
                    fun RememberSerializableDemo() {

                        var likesCount by remember { mutableIntStateOf(0) }

                        var draft by rememberSerializable(inputs = arrayOf(likesCount)) {
                            mutableStateOf(
                                NewsArticle(
                                    headline = "Trying rememberSerializable",
                                    text = "Some dummy text.",
                                    likesCount = likesCount
                                )
                            )
                        }
                    }
                    """.trimIndent()
            )
        }
    }
}
